import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OrchestrationResponse, RoutingStatusResponse } from '../models/report-response';
import { Observable } from 'rxjs';
import { AgentRequest, DocumentRequest } from '../models/agent-models/agent-request';
import { API_ENDPOINTS, buildEndpoint } from '../api-endpoint';
import { RuntimeConfigService } from '../config/runtime-config.service';
import { ApiResponse } from '../models/api-response';

@Injectable({
  providedIn: 'root',
})
export class AgentService {
  private baseApiUrl: string;
  private apiVersion: string;
  constructor(private runtimeConfigService: RuntimeConfigService, private http: HttpClient) {
    this.baseApiUrl = this.runtimeConfigService.apiUrl;
    this.apiVersion = this.runtimeConfigService.apiVersion;
  }

  getApiUrl(apiEndpoint: string): string {
    return buildEndpoint(this.baseApiUrl, this.apiVersion, 'reportagent', apiEndpoint);
  }

  invokeOrchestrationAgent(request: AgentRequest,report_id:string): Observable<ApiResponse<OrchestrationResponse>> {
    return this.http.post<ApiResponse<OrchestrationResponse>>(
      this.getApiUrl(API_ENDPOINTS.AGENT_SERVICE.StartOrchestration).replace('{reportId}',report_id.toString()),
      request
    );
  }

}
